export default "__VITE_ASSET__BUaWiSCl__"